import { createAction, props } from '@ngrx/store';

import { ErrorResponse } from '#types/core';
import { FacilityLookupResponseBody } from '#types/facility';
import { Filters, Sorts } from '#types/grid';
import { ListOfValuesResponse, MultipleListOfValuesResponse } from '#types/list';

//
// facility / request lists
//

export const RequestLists = createAction('[Facility] - Request Lists');

//
// facility lists
//
export const RequestFacilityLists = createAction('[Facility.Lists] - Request Facility Lists');
export const RequestFacilityListsSuccess = createAction(
  '[Facility.Lists] - Request Facility Lists Success',
  props<{ lists: MultipleListOfValuesResponse }>()
);
export const RequestFacilityListsFailure = createAction(
  '[Facility.Lists] - Request Facility Lists Failure',
  props<{ error: ErrorResponse }>()
);

//
// facility / dictionary field list
//

export const RequestFacilityDictionaryFieldList = createAction(
  '[Facility.Lists] - Request Facility Dictionary Field List',
  props<{ facility: string }>()
);
export const RequestFacilityDictionaryFieldListSuccess = createAction(
  '[Facility.Lists] - Request Facility Dictionary Field List Success',
  props<{ facility: string; list: ListOfValuesResponse }>()
);
export const RequestFacilityDictionaryFieldListFailure = createAction(
  '[Facility.Lists] - Request Facility Dictionary Field List Failure',
  props<{ error: ErrorResponse }>()
);

//
// facility / lookup dialog
//

export const FacilityLookupDialogRequestData = createAction('[Facility.Lookup.Dialog] - Grid Request Data', props<{ id: string }>());
export const FacilityLookupDialogRequestDataWithParameters = createAction(
  '[Facility.Lookup.Dialog] - Grid Request Data With Parameters',
  props<{ id: string; filters: Filters; page: number; first: number; rows: number; sorts: Sorts }>()
);
export const FacilityLookupDialogRequestDataWithFilters = createAction(
  '[Facility.Lookup.Dialog] - Grid Request Data With Filters',
  props<{ id: string; filters: Filters }>()
);
export const FacilityLookupDialogRequestDataSuccess = createAction(
  '[Facility.Lookup.Dialog] - Grid Request Data Success',
  props<{ id: string; data: FacilityLookupResponseBody }>()
);
export const FacilityLookupDialogRequestDataFailure = createAction(
  '[Facility.Lookup.Dialog] - Grid Request Data Failure',
  props<{ id: string }>()
);
